import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=25152b5c&scoped=true"
var script = {}
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=25152b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25152b5c",
  null
  
)

export default component.exports